export default "/images/a44e8339cced276738e1c6b5c7b65936.avif";